import Vue from 'vue'
import 'element-ui/lib/theme-chalk/icon.css'
import 'element-ui/lib/theme-chalk/radio.css'
import 'element-ui/lib/theme-chalk/radio-group.css'
import './element.styl'
import {
  // Button,
  // Dialog,
  // Upload,
  // Popover,
  // Radio,
  // RadioGroup,
  Message,
  // login
  // Checkbox,
  // Dropdown,
  // DropdownMenu,
  // DropdownItem,
  Loading,
  MessageBox
} from 'element-ui'

// Vue.use(Checkbox)
// Vue.use(Dropdown)
// Vue.use(DropdownMenu)
// Vue.use(DropdownItem)
// Vue.use(Button)
// Vue.use(Dialog)
// Vue.use(Upload)
// Vue.use(Popover)
// Vue.use(Radio)
// Vue.use(RadioGroup)

const _Loading = Loading
const { directive: loadingDirective } = _Loading

Vue.use(loadingDirective)
if (typeof window !== 'undefined') {
  const _MessageBox = MessageBox
  const { alert, confirm } = _MessageBox
  Vue.prototype.$alert = alert
  Vue.prototype.$confirm = confirm
  Vue.prototype.$message = Message
}
